import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../../shared/icon/icon'
import { Form, FormText, FormSubmitCancel } from '../../../../../shared/form/form'
import { useApiFormOrganization } from '../../../../../api-new/state/content'
import { Card } from '../../../../../shared/card/card'
import { useRoleSysOrganization } from '../../../../../role/hook/role-sys'

export function OrganizationAdd() {
  const history = useHistory()

  const apiFormOrganization = useApiFormOrganization()

  const roleSysOrganization = useRoleSysOrganization()

  const handleMatch = () => apiFormOrganization.init()

  // A refusal (a name already taken, say) is shown by the form, which stays.
  const handleSubmit = async data => {
    let organization = await apiFormOrganization.post(data)
    if (roleSysOrganization.accessUpdate) history.push(`/admin/organization/list/edit/${organization.id}`)
    else history.push(`/admin/organization/list`)
  }

  const handleCancel = () => history.push('/admin/organization/list')

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Add organization" onMatch={handleMatch}>
        <Card title="add organization">
          <Form submitting={apiFormOrganization.submitting} onSubmit={handleSubmit}>
            <FormText label="name" name="name" required autoFocus />
            <FormSubmitCancel text="add organization" onCancel={handleCancel} />
          </Form>
        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
